// Main entry point - export all public APIs
export * from './client.js'; // Exports JanusAPIv2Client, JanusClientOptions, JanusApiError
export * from './types.js'; // Exports all DTOs, common types, AND the Zone enum

// Export specific clients
export * from './clients/auth.client'; // Correct path
export * from './clients/data.client'; // Exports DataClient
export * from './clients/admin.client'; // Exports AdminClient
export * from './clients/logs.client'; // Exports LogsClient
export * from './clients/ai.client'; // Exports AiClient
export * from './clients/chat.client'; // Exports ChatClient

// Utils
export * from './utils/endpoint-resolver';
export * from './utils/chat-json';

// REMOVED problematic specific type re-exports
// export type { JanusClientOptions, JanusApiError } from './client';
// export { Zone } from './types'; 
// export type { ... } from './types';